import { Chip } from "@mui/material"

/**
 * One demand an auth bundle will confer, shown while the override is still being composed.
 *
 * Deliberately NOT GrantDemandChip: nothing has been saved yet, so there is no breakdown to say
 * whether the demand reaches the user. This chip only answers "what is in the bundle".
 */
export function BundleDemandChip({ item: demand }) {
    return <Chip size="small" variant="outlined" label={demand} data-cy={`bundle-demand-${demand}`} />
}
